import React from "react";
import { useTranslation } from "react-i18next";
import { MessageSquare } from "lucide-react";
import { RevenueChartCard } from "../revenue/RevenueChartCard";
import { SERVICES_CHART_CARD_ICON_COLOR } from "../services/constants";

interface ReviewsCommunicationReviewsCardProps {
  reviewsCount: number;
}

export const ReviewsCommunicationReviewsCard: React.FC<
  ReviewsCommunicationReviewsCardProps
> = ({ reviewsCount }) => {
  const { t } = useTranslation();

  return (
    <RevenueChartCard
      title={t(
        "analytics.reviews.communicationReviews.title",
        "Reviews for Communication",
      )}
      icon={<MessageSquare />}
      iconColor={SERVICES_CHART_CARD_ICON_COLOR}
      width="full"
      showExport={false}
    >
      <div className="flex min-h-[128px] flex-col items-center justify-center gap-2 text-center">
        <p className="text-[40px] leading-none font-semibold text-[#171717]">
          {reviewsCount}
        </p>
        <p className="text-sm leading-normal text-[#737373]">
          {t(
            "analytics.reviews.communicationReviews.total",
            "Total communication-related reviews",
          )}
        </p>
      </div>
    </RevenueChartCard>
  );
};
